export const NAV_LOADING = 'NAV_LOADING'
export const NAV_SUCCESS = 'NAV_SUCCESS'
export const NAV_ERROR = 'NAV_ERROR'
export const CHANGE_ROUTE = 'CHANGE_ROUTE'
export const TOGGLE_MENU = 'TOGGLE_MENU'
export const SORT_NAV = 'SORT_NAV'
export const HIGHLIGHT_NAVBAR_SECTION = 'HIGHLIGHT_NAVBAR_SECTION'
